import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styles from './requests-list.module.scss';
import { store } from 'react-notifications-component';
import Accordion from '@material-ui/core/Accordion';
import InfoIcon from '@material-ui/icons/Info';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Countdown from 'react-countdown';
import { ErrorInfo, isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import { RootState } from '../../../shared/redux/reducers';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import useWindowResizer from '../../../shared/hooks/window-resizer/window-resizer.hook';
import {
  BookingRequestUiModel,
  BookingRequestModelUiData
} from '../../../shared/ui-models/booking-request.ui-model';
import {
  acceptBookingRequest,
  rejectBookingRequest,
  submitBookingMessage,
  getBookingRequests,
  updateBookingRequest
} from '../../shared/services/data.service';
import { BookingRequestDetails } from './components/booking-request-details/booking-request-details.component';
import moment from 'moment';
import { BookingRequestStatus } from '../../../shared/enums/booking-request-status.enum';
import { Tabs, TabsPosition } from '../../../shared/components/group-ui/tabs/tabs.component';
import { SelectAvailableRoom } from './components/select-available-room/select-available-room.component';
import { TextArea } from '../../../shared/components/core-ui/text-area/text-area.component';
import Button from '../../../shared/components/core-ui/button/button.component';
import { MessagesList } from '../../../shared/models/booking-request.model';
import { RejectRequest } from './components/reject-request/reject-request.component';
import { getBookingRequestDetails } from '../../../shared/services/data/booking.data';
import { getModuleName } from '../../shared/services/booking.service';
import { PUBLIC_PATH } from '../../../shared/config/routes-config';
import { Pagination } from '../../../shared/components/core-ui/pagination/pagination.component';
import { CreateBookingRequestModal } from './components/new-booking-request-modal/new-booking-request-modal.component';
import { hasAccess } from '../../../shared/services/helpers/auth-helper/auth-helper.service';
import { PERMISSIONS_LIST } from '../../../shared/config/permissions.config';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { Button as MIButton, Menu, MenuItem } from '@material-ui/core';
import { ReservationSource } from '../../../shared/enums/reservation-souce.enum';
import {
  FilterRequestList,
  FilterRequestListrModel
} from './components/filter-request-list/filter-request-list.component';
import isEmpty from 'lodash/isEmpty';
import { NotFoundData } from '../../../ui/NotFoundData';
export type RequestsListContainerProps = ReturnType<typeof mapStateToProps>;

/**
 * functional component RequestsListContainer
 * @param {RequestsListContainerProps} holding question text
 */
export const RequestsListContainer: React.FC<RequestsListContainerProps> = ({
  isAuthenticated
}) => {
  const [bookingRequestsList, setBookingRequestsList] = useState<BookingRequestUiModel[]>([]);
  const [urgentList, setUrgentList] = useState<BookingRequestUiModel[]>([]);
  const [rejectedList, setRejectedList] = useState<BookingRequestUiModel[]>([]);
  const [showRoomsModal, setShowRoomsModal] = useState<boolean>(false);
  const [showRejectModal, setShowRejectModal] = useState<boolean>(false);
  const [selectedBookingRequest, setSelectedBookingRequest] = useState<BookingRequestUiModel>();
  const [bookingRequestMsg, setBookingRequestMsg] = useState<string>('');
  const [messagesListAfterSubmit, setMessagesListAfterSubmit] = useState<MessagesList[]>([]);
  const [listCount, setListCount] = useState<number>(0);
  const [offset, setOffset] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [selectedTabs, setSelectedTabs] = useState<any>({
    status: BookingRequestStatus.IN_SCREENING
  });
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [showCreateNewRequestModel, setShowCreateNewRequestModel] = useState<boolean>(false);
  const [showEditRequestModel, setShowEditRequestModel] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [requestIdSelect, setRequestIdSelect] = useState<string | undefined>(undefined);
  const [currentTime, setCurrentTime] = useState<number>(Date.now());

  const { t } = useTranslation();
  useEffect(() => {
    if (messagesListAfterSubmit) getAllBookingRequestsData(selectedTabs, 1, limit);
  }, [messagesListAfterSubmit]);

  useEffect(() => {
    // getAllBookingRequestsData(selectedTabs, 1, limit);
    return () => {
      store.removeNotification('edit-booking-request-failed');
      store.removeNotification('edit-booking-request-success');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getAllBookingRequestsData(selectedTabs, offset, limit);
  }, [limit]);

  // Timer to update UI every second for countdown
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const getAllBookingRequestsData = (query: object, offset: number, limit: number) => {
    setLoadingData(true);

    getBookingRequests(query, offset, limit).then(
      (response: BookingRequestModelUiData | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          setLoadingData(false);
          setListCount(response.count);
          const res = response.BookingRequestList.sort((a, b) => {
            if (a.bookedAt && b.bookedAt && a.bookedAt > b.bookedAt) {
              return 1;
            } else {
              return -1;
            }
          });
          res.forEach((item) => {
            item.submitMessage = '';
          });
          setBookingRequestsList(res);
        } else {
          setLoadingData(false);
          setBookingRequestsList([]);
        }
      }
    );
  };
  const acceptRequest = (requestId: string, roomId: string) => {
    acceptBookingRequest(requestId, roomId).then((requestItem) => {
      if (!isErrorInfo(requestItem)) {
        store.addNotification({
          title: 'Booking request accepted successfully',
          message: 'Confirmation email will be sent to guest shortly',
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
        const bookRequestTemp = [...bookingRequestsList];
        const foundRequestIndex = bookRequestTemp.findIndex(
          (request) => request.requestId === requestId
        );
        if (foundRequestIndex > -1) {
          bookRequestTemp[foundRequestIndex] = {
            ...requestItem,
            ...bookRequestTemp[foundRequestIndex]
          };
          setBookingRequestsList(bookRequestTemp);
        }
        const urgentTempList = urgentList.filter((request) => request.requestId !== requestId);
        const rejectList = urgentList.filter(
          (request) => request.status === BookingRequestStatus.REJECTED
        );
        setUrgentList(urgentTempList);
        setRejectedList(rejectList);
      } else {
        store.addNotification({
          id: 'edit-booking-request-failed',
          title: requestItem.status === 403 ? 'Permission denied' : 'Booking conflict',
          message:
            requestItem.status === 403
              ? "You don't have the sufficient permissions to edit this book"
              : 'Room is already reserved for another guest',
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut']
        });
      }
    });
  };
  const rejectRequest = (requestId: string, rejectionReason: string) => {
    rejectBookingRequest(requestId, rejectionReason).then((requestItem) => {
      if (!isErrorInfo(requestItem)) {
        store.addNotification({
          title: 'Booking request rejected successfully',
          message: 'Confirmation email will be sent to guest shortly',
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
      }
    });
    getAllBookingRequestsData({}, 1, limit);
  };
  const submitRequestMsg = (requestId: string) => {
    submitBookingMessage(bookingRequestMsg, requestId).then((response: any) => {
      setMessagesListAfterSubmit([]);
      setBookingRequestMsg('');
      if (!isErrorInfo(response)) {
        setMessagesListAfterSubmit(response.messagesList);

        store.addNotification({
          title: 'Booking request message submit successfully',
          message: 'Confirmation email will be sent to guest shortly',
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
        setBookingRequestMsg('');
      } else {
        store.addNotification({
          id: 'edit-booking-request-msg-failed',
          title: 'Booking conflict',
          message: 'submit message failed',
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut']
        });
      }
    });
  };
  const checkRoomAvailability = (requestId: string) => {
    getBookingRequestDetails(requestId, getModuleName()).then((requestItem) => {
      if (!isErrorInfo(requestItem)) {
        if (requestItem && requestItem.availableRooms && requestItem.availableRooms.length > 0) {
          setSelectedBookingRequest(requestItem);
          setShowRoomsModal(true);
        } else {
          store.addNotification({
            id: 'edit-booking-request-failed',
            title: 'Booking conflict',
            message: 'No available room for the selected dates',
            type: 'danger',
            insert: 'top',
            container: 'top-right',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut']
          });
        }
      } else {
        store.addNotification({
          id: 'edit-booking-request-failed',
          title: 'Booking conflict',
          message: 'No available room for the selected dates',
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut']
        });
      }
    });
  };
  const getNewBooking = (offsetNumber: number) => {
    setOffset(offsetNumber);
    getAllBookingRequestsData(selectedTabs, offsetNumber, limit);
  };

  const handleUpdateBookingStatus = (requestId: string, data: any) => {
    updateBookingRequest(requestId, data).then((response) => {
      if (!isErrorInfo(response)) {
        getAllBookingRequestsData({ status: BookingRequestStatus.NEW }, 1, limit);
        store.addNotification({
          title: 'Booking request status updated successfully',
          message: 'The booking request status has been updated',
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
      } else {
        store.addNotification({
          title: 'Failed to update booking request status',
          message: 'An error occurred while updating the booking request status',
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut']
        });
      }
    });
  };

  const isMissingDetailsButtonDisabled = (bookingRequest: BookingRequestUiModel) => {
    const now = moment();
    const twoHoursInMs = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

    // Check if all three contacts have been made
    if (
      bookingRequest?.missingDetailsFirstContactedAt &&
      bookingRequest?.missingDetailsSecondContactedAt &&
      bookingRequest?.missingDetailsThirdContactedAt
    ) {
      return true; // Permanently disabled
    }

    // Check if we need to wait 2 hours after first contact
    if (
      bookingRequest?.missingDetailsFirstContactedAt &&
      !bookingRequest?.missingDetailsSecondContactedAt &&
      !bookingRequest?.missingDetailsThirdContactedAt
    ) {
      const timeSinceFirstContact = now.valueOf() - bookingRequest.missingDetailsFirstContactedAt;
      return timeSinceFirstContact < twoHoursInMs;
    }

    // Check if we need to wait 2 hours after second contact
    if (
      bookingRequest?.missingDetailsFirstContactedAt &&
      bookingRequest?.missingDetailsSecondContactedAt &&
      !bookingRequest?.missingDetailsThirdContactedAt
    ) {
      const timeSinceSecondContact = now.valueOf() - bookingRequest.missingDetailsSecondContactedAt;
      return timeSinceSecondContact < twoHoursInMs;
    }

    return false; // Button is enabled
  };

  const handleMissingDetailsContactClick = (request: BookingRequestUiModel) => {
    const data: {
      missingDetailsFirstContactedAt?: number;
      missingDetailsSecondContactedAt?: number;
      missingDetailsThirdContactedAt?: number;
    } = {};

    if (!request.missingDetailsFirstContactedAt) {
      data.missingDetailsFirstContactedAt = moment(new Date()).valueOf();
    } else if (!request.missingDetailsSecondContactedAt) {
      data.missingDetailsSecondContactedAt = moment(new Date()).valueOf();
    } else if (!request.missingDetailsThirdContactedAt) {
      data.missingDetailsThirdContactedAt = moment(new Date()).valueOf();
    }

    updateBookingRequest(request.requestId, data).then((response) => {
      if (!isErrorInfo(response)) {
        getAllBookingRequestsData({ status: BookingRequestStatus.IN_SCREENING }, 1, limit);
        store.addNotification({
          title: 'Missing Details Contact updated successfully',
          message: 'The missing details contact has been updated',
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
      } else {
        store.addNotification({
          title: 'Failed to update missing details contact',
          message: 'An error occurred while updating the missing details contact',
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut']
        });
      }
    });
  };

  const isContactButtonDisabled = (bookingRequest: BookingRequestUiModel) => {
    const now = moment();
    const twoHoursInMs = 2 * 60 * 60 * 1000;

    if (
      bookingRequest?.noResponseFirstContactedAt &&
      bookingRequest?.noResponseSecondContactedAt &&
      bookingRequest?.noResponseThirdContactedAt
    ) {
      return true;
    }

    if (
      bookingRequest?.noResponseFirstContactedAt &&
      !bookingRequest?.noResponseSecondContactedAt &&
      !bookingRequest?.noResponseThirdContactedAt
    ) {
      const timeSinceFirstContact = now.valueOf() - bookingRequest.noResponseFirstContactedAt;
      return timeSinceFirstContact < twoHoursInMs;
    }

    if (
      bookingRequest?.noResponseFirstContactedAt &&
      bookingRequest?.noResponseSecondContactedAt &&
      !bookingRequest?.noResponseThirdContactedAt
    ) {
      const timeSinceSecondContact = now.valueOf() - bookingRequest.noResponseSecondContactedAt;
      return timeSinceSecondContact < twoHoursInMs;
    }

    return false;
  };

  const handleNoResponseContactClick = (request: BookingRequestUiModel) => {
    const data: {
      noResponseFirstContactedAt?: number;
      noResponseSecondContactedAt?: number;
      noResponseThirdContactedAt?: number;
    } = {};

    if (!request.noResponseFirstContactedAt) {
      data.noResponseFirstContactedAt = moment(new Date()).valueOf();
    } else if (!request.noResponseSecondContactedAt) {
      data.noResponseSecondContactedAt = moment(new Date()).valueOf();
    } else if (!request.noResponseThirdContactedAt) {
      data.noResponseThirdContactedAt = moment(new Date()).valueOf();
    }

    updateBookingRequest(request.requestId, data).then((response) => {
      if (!isErrorInfo(response)) {
        getAllBookingRequestsData({ status: BookingRequestStatus.IN_SCREENING }, 1, limit);
        store.addNotification({
          title: 'No Response Contact updated successfully',
          message: 'The no response contact has been updated',
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
      } else {
        store.addNotification({
          title: 'Failed to update no response contact',
          message: 'An error occurred while updating the no response contact',
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut']
        });
      }
    });
  };

  const renderRequestsList = () => (
    <div className={styles['requests-list-container__list-wrapper']}>
      {bookingRequestsList && bookingRequestsList.length > 0 ? (
        bookingRequestsList.map((bookingRequest, index) => (
          <div
            key={index}
            className={`${styles['requests-list-container__request-item']} ${
              styles['requests-list-container__request-item__' + bookingRequest.status]
            }`}
          >
            <Accordion key={index} TransitionProps={{ unmountOnExit: true, mountOnEnter: true }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-label="Expand"
                aria-controls="additional-actions1-content"
                id={bookingRequest.requestId}
              >
                <div className={styles['requests-list-container__request-wrapper']}>
                  {bookingRequest.status === BookingRequestStatus.IN_SCREENING &&
                    bookingRequest.bookedAt && (
                      <div className={styles['requests-list-container__request-wrapper__header']}>
                        {moment().diff(moment(Number(bookingRequest.bookedAt)), 'hours') >= 24 ? (
                          <div
                            className={`${styles['requests-list-container__notification']} ${styles['requests-list-container__notification--error']}`}
                          >
                            <InfoIcon fontSize={'large'} />
                            <div
                              className={styles['requests-list-container__notification__message']}
                            >
                              Response was expected{' '}
                              <b>
                                {moment(
                                  bookingRequest.bookedAt
                                    ? Number(bookingRequest.bookedAt)
                                    : new Date().getTime()
                                ).fromNow()}
                              </b>
                            </div>
                          </div>
                        ) : (
                          <div className={styles['requests-list-container__time-left']}>
                            <b>Time Left:</b>{' '}
                            <Countdown
                              date={
                                new Date(
                                  new Date(Number(bookingRequest.bookedAt)).getTime() +
                                    60 * 60 * 24 * 1000
                                )
                              }
                            >
                              <div
                                className={`${styles['requests-list-container__notification']} ${styles['requests-list-container__notification--error']}`}
                              >
                                <InfoIcon />
                                Response was expected{' '}
                                {moment(Number(bookingRequest.bookedAt)).add(24, 'hours').fromNow()}
                              </div>
                            </Countdown>
                          </div>
                        )}
                      </div>
                    )}
                  {bookingRequest.bookedAt && (
                    <div>
                      <b>Requested At:</b>{' '}
                      {moment(Number(bookingRequest.bookedAt)).format('DD-MM-YYYY HH:mm a')}
                    </div>
                  )}
                  {bookingRequest.screenedAt && (
                    <div>
                      <b>Requested At:</b>{' '}
                      {moment(Number(bookingRequest.screenedAt)).format('DD-MM-YYYY HH:mm a')}
                    </div>
                  )}
                  <div>
                    <b>Status:</b> {bookingRequest.status}
                  </div>
                  <div>
                    <b>name:</b> {bookingRequest.guestInfo.name}
                  </div>
                  {bookingRequest.bookingInfo.checkOutDate &&
                    bookingRequest.bookingInfo.checkInDate && (
                      <div>
                        <b>Duration:</b>{' '}
                        {moment(Number(bookingRequest.bookingInfo.checkOutDate)).diff(
                          moment(Number(bookingRequest.bookingInfo.checkInDate)),
                          'days'
                        ) + 1}{' '}
                        Days
                      </div>
                    )}
                  {/* <div>name: {bookingRequest.bookingInfo.}</div> */}
                  {bookingRequest.status === BookingRequestStatus.IN_SCREENING && (
                    <>
                      <div className={styles['requests-list-container__contact-actions']}>
                        <Button
                          onClick={() => handleNoResponseContactClick(bookingRequest)}
                          disabled={isContactButtonDisabled(bookingRequest)}
                        >
                          Contact but not answered
                          {isContactButtonDisabled(bookingRequest) &&
                            bookingRequest?.noResponseFirstContactedAt && (
                              <Countdown
                                key={`countdown-${bookingRequest.requestId}-${currentTime}`}
                                date={
                                  new Date(
                                    (bookingRequest?.noResponseSecondContactedAt ||
                                      bookingRequest?.noResponseFirstContactedAt ||
                                      0) +
                                      2 * 60 * 60 * 1000
                                  )
                                }
                                renderer={({ hours, minutes, seconds, completed }) => {
                                  if (completed) {
                                    return null;
                                  }
                                  return (
                                    <span style={{ fontSize: '12px', marginLeft: '8px' }}>
                                      ({hours}h {minutes}m {seconds}s)
                                    </span>
                                  );
                                }}
                              />
                            )}
                        </Button>
                        <Button
                          onClick={() => handleMissingDetailsContactClick(bookingRequest)}
                          disabled={isMissingDetailsButtonDisabled(bookingRequest)}
                        >
                          Contact and waiting for details
                          {isMissingDetailsButtonDisabled(bookingRequest) &&
                            bookingRequest?.missingDetailsFirstContactedAt && (
                              <Countdown
                                key={`countdown-missing-${bookingRequest.requestId}-${currentTime}`}
                                date={
                                  new Date(
                                    (bookingRequest?.missingDetailsSecondContactedAt ||
                                      bookingRequest?.missingDetailsFirstContactedAt ||
                                      0) +
                                      2 * 60 * 60 * 1000
                                  )
                                }
                                renderer={({ hours, minutes, seconds, completed }) => {
                                  if (completed) {
                                    return null;
                                  }
                                  return (
                                    <span style={{ fontSize: '12px', marginLeft: '8px' }}>
                                      ({hours}h {minutes}m {seconds}s)
                                    </span>
                                  );
                                }}
                              />
                            )}
                        </Button>
                      </div>
                      <div
                        className={styles['requests-list-container__contact-tracking']}
                        style={{ marginTop: '16px' }}
                      >
                        <div className={styles['requests-list-container__contact-sections-row']}>
                          <div className={styles['requests-list-container__contact-section']}>
                            <h4 className={styles['requests-list-container__section-title']}>
                              📞 No Response Contact History
                            </h4>
                            <div className={styles['requests-list-container__contact-timeline']}>
                              {[
                                {
                                  time: bookingRequest?.noResponseFirstContactedAt,
                                  by: bookingRequest?.noResponseContactedBy?.firstContactedBy,
                                  label: '1st Contact'
                                },
                                {
                                  time: bookingRequest?.noResponseSecondContactedAt,
                                  by: bookingRequest?.noResponseContactedBy?.secondContactedBy,
                                  label: '2nd Contact'
                                },
                                {
                                  time: bookingRequest?.noResponseThirdContactedAt,
                                  by: bookingRequest?.noResponseContactedBy?.thirdContactedBy,
                                  label: '3rd Contact'
                                }
                              ].map((contact, index) => (
                                <div
                                  key={`no-response-${index}`}
                                  className={`${styles['requests-list-container__contact-item']} ${
                                    contact.time ? styles['completed'] : styles['pending']
                                  }`}
                                >
                                  <div
                                    className={styles['requests-list-container__contact-indicator']}
                                  >
                                    <span
                                      className={styles['requests-list-container__contact-number']}
                                    >
                                      {index + 1}
                                    </span>
                                  </div>
                                  <div
                                    className={styles['requests-list-container__contact-details']}
                                  >
                                    <div
                                      className={styles['requests-list-container__contact-label']}
                                    >
                                      {contact.label}
                                    </div>
                                    <div
                                      className={styles['requests-list-container__contact-time']}
                                    >
                                      {contact.time
                                        ? moment(contact.time).format('MMM DD, YYYY • hh:mm A')
                                        : 'Not contacted yet'}
                                    </div>
                                    {contact.by && (
                                      <div
                                        className={styles['requests-list-container__contact-by']}
                                      >
                                        By: {contact.by}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          <div className={styles['requests-list-container__contact-section']}>
                            <h4 className={styles['requests-list-container__section-title']}>
                              📋 Missing Details Contact History
                            </h4>
                            <div className={styles['requests-list-container__contact-timeline']}>
                              {[
                                {
                                  time: bookingRequest?.missingDetailsFirstContactedAt,
                                  by: bookingRequest?.missingDetailsContactedBy?.firstContactedBy,
                                  label: '1st Contact'
                                },
                                {
                                  time: bookingRequest?.missingDetailsSecondContactedAt,
                                  by: bookingRequest?.missingDetailsContactedBy?.secondContactedBy,
                                  label: '2nd Contact'
                                },
                                {
                                  time: bookingRequest?.missingDetailsThirdContactedAt,
                                  by: bookingRequest?.missingDetailsContactedBy?.thirdContactedBy,
                                  label: '3rd Contact'
                                }
                              ].map((contact, index) => (
                                <div
                                  key={`missing-details-${index}`}
                                  className={`${styles['requests-list-container__contact-item']} ${
                                    contact.time ? styles['completed'] : styles['pending']
                                  }`}
                                >
                                  <div
                                    className={styles['requests-list-container__contact-indicator']}
                                  >
                                    <span
                                      className={styles['requests-list-container__contact-number']}
                                    >
                                      {index + 1}
                                    </span>
                                  </div>
                                  <div
                                    className={styles['requests-list-container__contact-details']}
                                  >
                                    <div
                                      className={styles['requests-list-container__contact-label']}
                                    >
                                      {contact.label}
                                    </div>
                                    <div
                                      className={styles['requests-list-container__contact-time']}
                                    >
                                      {contact.time
                                        ? moment(contact.time).format('MMM DD, YYYY • hh:mm A')
                                        : 'Not contacted yet'}
                                    </div>
                                    {contact.by && (
                                      <div
                                        className={styles['requests-list-container__contact-by']}
                                      >
                                        By: {contact.by}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={styles['requests-list-container__actions']}>
                        <div
                          className={styles['requests-list-container__actions__choice']}
                          onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                            event.stopPropagation();
                            if (
                              !bookingRequest?.bookingInfo?.unitTypeId ||
                              !bookingRequest?.bookingInfo?.checkInDate ||
                              !bookingRequest?.bookingInfo?.checkOutDate
                            ) {
                              store.addNotification({
                                title: "No can't accept this booking",
                                message:
                                  'Please fill missing booking details first (like unit type, check-in and check-out dates) before accepting the request.',
                                type: 'danger',
                                insert: 'top',
                                container: 'top-right',
                                animationIn: ['animate__animated', 'animate__fadeIn'],
                                animationOut: ['animate__animated', 'animate__fadeOut'],
                                dismiss: {
                                  duration: 3500,
                                  onScreen: true
                                }
                              });
                              return;
                            }
                            checkRoomAvailability(bookingRequest.requestId);
                          }}
                        >
                          Accept
                        </div>
                        <div
                          className={styles['requests-list-container__actions__choice']}
                          onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                            event.stopPropagation();
                            setSelectedBookingRequest(bookingRequest);
                            setShowRejectModal(true);
                          }}
                        >
                          Reject
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    key={index}
                    className={styles['requests-list-container__actions__message']}
                    onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                      event.stopPropagation();
                    }}
                  >
                    <TextArea
                      key={index}
                      data={{
                        value: bookingRequest.submitMessage,
                        placeholder: t(
                          'AMENITY_MODULE.LIST_CONTAINER.ADD_NEW_MODAL.NAME_PLACEHOLDER'
                        )
                      }}
                      config={{
                        maxRows: 1
                        // autoFocus: false
                      }}
                      eventHandlers={{
                        onChangeHandler: (value: string) => {
                          setBookingRequestMsg(value);
                          bookingRequest.submitMessage = value;
                        }
                      }}
                    />
                    <div className={styles['requests-list-container__actions']}>
                      {bookingRequest?.source === ReservationSource.BN_ADMIN && (
                        <Button
                          className={styles['requests-list-container__actions__message-submit']}
                          onClick={() => {
                            setRequestIdSelect(bookingRequest?.requestId);
                            setShowEditRequestModel(true);
                          }}
                        >
                          Edit
                        </Button>
                      )}
                      <Button
                        className={styles['requests-list-container__actions__message-submit']}
                        onClick={() => submitRequestMsg(bookingRequest.requestId || '')}
                      >
                        submit
                      </Button>
                    </div>
                    <div
                      className={styles['requests-list-container__actions__message_view-container']}
                    >
                      {bookingRequest.messagesList.map(
                        (msg) =>
                          msg.message && (
                            <div
                              className={styles['requests-list-container__actions__message_view']}
                            >
                              <div
                                className={
                                  styles['requests-list-container__actions__message_view__details']
                                }
                              >
                                created At: <span>{new Date(msg.createdAt).toDateString()}</span>by:{' '}
                                <label>{msg.createdByUsername}</label>
                              </div>
                              <p
                                className={
                                  styles['requests-list-container__actions__message_view__msg']
                                }
                              >
                                {' '}
                                {msg.message}
                              </p>
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </div>
              </AccordionSummary>

              <AccordionDetails>
                <div className={styles['requests-list-container__request-item__details']}>
                  <BookingRequestDetails data={bookingRequest} />
                </div>
              </AccordionDetails>
            </Accordion>{' '}
          </div>
        ))
      ) : (
        <NotFoundData />
      )}
      {listCount > 0 && (
        <Pagination
          itemCounts={listCount}
          itemsPerPage={limit}
          offset={offset}
          handlePageChange={(val) => {
            setOffset(1);
            getNewBooking(val);
          }}
          handleItemsPerPage={(itemsPerPage) => {
            setLimit(itemsPerPage);
          }}
        />
      )}
    </div>
  );

  const renderNewRequestList = () => (
    <>
      <TableContainer
        style={{
          marginTop: '20px'
        }}
        component={Paper}
      >
        <Table aria-label="table">
          <TableHead style={{ backgroundColor: '#f5f5f5' }}>
            <TableRow>
              <TableCell />
              <TableCell>Name</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Check In</TableCell>
              <TableCell>Check Out</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bookingRequestsList && bookingRequestsList.length > 0 ? (
              bookingRequestsList.map((bookingRequest) => {
                return (
                  <>
                    <TableRow key={bookingRequest?.requestId}>
                      <TableCell />
                      <TableCell>{bookingRequest.guestInfo?.name}</TableCell>
                      <TableCell>{bookingRequest.guestInfo?.phoneNumber}</TableCell>
                      <TableCell>
                        {bookingRequest.bookingInfo?.checkInDate
                          ? new Date(Number(bookingRequest.bookingInfo.checkInDate)).toDateString()
                          : '-'}
                      </TableCell>
                      <TableCell>
                        {bookingRequest.bookingInfo?.checkOutDate
                          ? new Date(Number(bookingRequest.bookingInfo.checkOutDate)).toDateString()
                          : '-'}
                      </TableCell>
                      <TableCell>
                        <MIButton
                          aria-controls="area-menu"
                          aria-haspopup="true"
                          onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                            event.stopPropagation();
                            event.preventDefault();
                            setAnchorEl(event.currentTarget);
                            setRequestIdSelect(bookingRequest?.requestId);
                          }}
                        >
                          <MoreHorizIcon fontSize={'large'} color="inherit" />
                        </MIButton>
                      </TableCell>
                    </TableRow>
                  </>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No booking requests found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Menu
        id="amenity-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={(event: any) => {
          if (event && event.stopPropagation) event.stopPropagation();
          if (event && event.preventDefault) event.preventDefault();
          setAnchorEl(null);
        }}
      >
        <MenuItem
          onClick={() => {
            if (requestIdSelect) {
              handleUpdateBookingStatus(requestIdSelect, {
                status: BookingRequestStatus.IN_SCREENING
              });
              setAnchorEl(null);
            }
          }}
        >
          Update to In-Screening
        </MenuItem>
        <MenuItem
          onClick={() => {
            setShowEditRequestModel(true);
          }}
        >
          Edit
        </MenuItem>
      </Menu>
    </>
  );
  return (
    <>
      <div className={styles['requests-list-container']}>
        <div className={styles['requests-list-container__title']}>
          <div>{t('BOOKING_MODULE.REQUESTS_LIST.TITLE')}</div>
          {hasAccess([
            PERMISSIONS_LIST.reservationsFullAccess,
            PERMISSIONS_LIST.reservationsModifyAccess
          ]) && (
            <Button onClick={() => setShowCreateNewRequestModel(true)}>Create New Booking</Button>
          )}
        </div>

        <Tabs
          data={{
            tabsList: [
              { component: <></>, key: 'Rejected' },
              { component: <></>, key: 'Require Action' },
              { component: <></>, key: 'All' },
              { component: <></>, key: 'New Requests' }
            ],
            defaultTab: 'Require Action'
          }}
          style={{ position: TabsPosition.LEFT }}
          eventHandlers={{
            tabChangeHandler: (tabKey) => {
              setOffset(1);
              if (tabKey === 'All') {
                setSelectedTabs({});
                getAllBookingRequestsData({}, 1, limit);
              } else if (tabKey === 'Require Action') {
                setSelectedTabs({ status: BookingRequestStatus.IN_SCREENING });

                getAllBookingRequestsData({ status: BookingRequestStatus.IN_SCREENING }, 1, limit);
              } else if (tabKey === 'Rejected') {
                setSelectedTabs({ status: BookingRequestStatus.REJECTED });

                getAllBookingRequestsData({ status: BookingRequestStatus.REJECTED }, 1, limit);
              } else if (tabKey === 'New Requests') {
                setSelectedTabs({ status: BookingRequestStatus.NEW });

                getAllBookingRequestsData({ status: BookingRequestStatus.NEW }, 1, limit);
              }
            }
          }}
        />
        <FilterRequestList
          eventHandlers={{
            search: (filterModel: FilterRequestListrModel) => {
              if (
                isEmpty(filterModel) ||
                (!filterModel.checkInDate &&
                  !filterModel.checkOutDate &&
                  !filterModel.name &&
                  !filterModel.phoneNumber &&
                  !filterModel.creationDateFrom &&
                  !filterModel.creationDateTo)
              ) {
                setOffset(1);
                getAllBookingRequestsData({ ...selectedTabs }, 1, limit);
              } else {
                getAllBookingRequestsData({ ...selectedTabs, ...filterModel }, 1, limit);
              }
            }
          }}
        />
        {loadingData ? (
          <div className={styles['reservation-list-container__loader']}>
            <img src={`${PUBLIC_PATH}/assets/svgs/loader.svg`} alt="loader" />
          </div>
        ) : (
          <>
            {selectedTabs.status === BookingRequestStatus.NEW
              ? renderNewRequestList()
              : renderRequestsList()}
          </>
        )}
        <SelectAvailableRoom
          data={{ availableRooms: selectedBookingRequest?.availableRooms || [] }}
          config={{ showModal: showRoomsModal }}
          eventHandlers={{
            cancelHandler: () => {
              setShowRoomsModal(false);
              setSelectedBookingRequest(undefined);
            },
            submitRoomSelected: (roomId: string) => {
              setShowRoomsModal(false);
              if (selectedBookingRequest && selectedBookingRequest.requestId) {
                acceptRequest(selectedBookingRequest?.requestId, roomId);
              }
              setSelectedBookingRequest(undefined);
            }
          }}
        />

        <RejectRequest
          config={{ showModal: showRejectModal }}
          eventHandlers={{
            cancelHandler: () => {
              setShowRejectModal(false);
              setSelectedBookingRequest(undefined);
            },
            rejectReason: (reason: string) => {
              rejectRequest(selectedBookingRequest?.requestId || '', reason);
              setShowRejectModal(false);
              setSelectedBookingRequest(undefined);
            }
          }}
        />
      </div>
      {showCreateNewRequestModel && (
        <CreateBookingRequestModal
          config={{
            showModal: showCreateNewRequestModel
          }}
          eventHandlers={{
            closeHandler: (updateTable) => {
              setShowCreateNewRequestModel(false);
              setAnchorEl(null);
              if (updateTable) {
                getAllBookingRequestsData({ status: BookingRequestStatus.NEW }, 1, limit);
              }
            },
            updateHandler: (data) => {
              updateBookingRequest(requestIdSelect || '', data).then((response) => {
                if (!isErrorInfo(response)) {
                  getAllBookingRequestsData({ status: BookingRequestStatus.NEW }, 1, limit);
                  setAnchorEl(null);
                  setShowCreateNewRequestModel(false);
                  store.addNotification({
                    title: 'Booking request status updated successfully',
                    message: 'The booking request status has been updated',
                    type: 'success',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                      duration: 3000,
                      onScreen: true
                    }
                  });
                } else {
                  store.addNotification({
                    title: 'Failed to update booking request status',
                    message: 'An error occurred while updating the booking request status',
                    type: 'danger',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut']
                  });
                }
              });
            }
          }}
        />
      )}
      {showEditRequestModel && (
        <CreateBookingRequestModal
          config={{
            showModal: showEditRequestModel,
            editData: bookingRequestsList.find((item) => item.requestId === requestIdSelect)
          }}
          eventHandlers={{
            closeHandler: (updateTable) => {
              setShowEditRequestModel(false);
              setAnchorEl(null);
              if (updateTable) {
                getAllBookingRequestsData({ status: BookingRequestStatus.NEW }, 1, limit);
              }
            },
            updateHandler: (data) => {
              updateBookingRequest(requestIdSelect || '', data).then((response) => {
                if (!isErrorInfo(response)) {
                  getAllBookingRequestsData({ status: selectedTabs.status }, 1, limit);
                  setAnchorEl(null);
                  setShowEditRequestModel(false);
                  store.addNotification({
                    title: 'Booking request status updated successfully',
                    message: 'The booking request status has been updated',
                    type: 'success',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                      duration: 3000,
                      onScreen: true
                    }
                  });
                } else {
                  store.addNotification({
                    title: 'Failed to update booking request status',
                    message: 'An error occurred while updating the booking request status',
                    type: 'danger',
                    insert: 'top',
                    container: 'top-right',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut']
                  });
                }
              });
            }
          }}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps)(RequestsListContainer);

/**
 * function to to map redux state to component props
 * @param state root state or redux
 */
function mapStateToProps(state: RootState) {
  return {
    isAuthenticated: !!state.auth.accessToken
  };
}
